
import { CarJobCategory } from "../../keep/constants/keep-basic-data";
import { CarRefItemStatus } from "../constants/car-basic-data";
import { CarJobTask } from "./car-job-task.model";


export class CarJobTemplate {
    id: number = 0;
    
    code = '';
    title = '';
    category: CarJobCategory = CarJobCategory.REVISION;
    details = '';
    tasks: CarJobTask[] = [];

    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, title: string)  {
        this.code = code!;
        this.title = title!;
    }
  }
  